import { useState, useEffect } from "react";
import api from "../api/api";

export default function Toners() {
  const [toners, setToners] = useState([]);
  const [clients, setClients] = useState([]);
  const [printers, setPrinters] = useState([]);
  const [tonerHistory, setTonerHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  
  // Controle Nativos de Modais (Fim do X duplo)
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [selectedToner, setSelectedToner] = useState(null);

  // Formulário unificado com Lucro e Venda
  const [addForm, setAddForm] = useState({ 
      id: null, model: "", color: "PRETO", stock: 0, 
      cost_price: "", profit_margin: "", sale_price: "" 
  });
  
  // 🚀 ESTADOS DO NOVO CARRINHO LOGÍSTICO
  const [rowQuantities, setRowQuantities] = useState({});
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [globalClient, setGlobalClient] = useState("");
  const [globalPrinter, setGlobalPrinter] = useState("");

  const generatedDescription = `Toner ${addForm.model} - ${addForm.color}`.toUpperCase();

  async function loadInitialData() {
    try {
      const [resToners, resClients, resPrinters] = await Promise.all([
        api.get("/toner"), api.get("/clients"), api.get("/printers")
      ]);
      setToners(resToners.data || []);
      setClients(resClients.data || []);
      setPrinters(resPrinters.data || []);
    } catch (err) { console.error("Erro ao carregar dados:", err); }
  }

  useEffect(() => { loadInitialData(); }, []);

  // 🚀 Matemática SGBr (Preservada)
  const handlePricingChange = (field, value) => {
    let newForm = { ...addForm, [field]: value };
    
    const cost = parseFloat(newForm.cost_price) || 0;
    const margin = parseFloat(newForm.profit_margin) || 0;
    const sale = parseFloat(newForm.sale_price) || 0;

    if (field === 'cost_price' || field === 'profit_margin') {
        const newSale = cost + (cost * (margin / 100));
        newForm.sale_price = newSale.toFixed(2);
    } 
    else if (field === 'sale_price' && cost > 0) {
        const newMargin = ((sale - cost) / cost) * 100;
        newForm.profit_margin = newMargin.toFixed(2);
    }
    setAddForm(newForm);
  };

  const handleImportNFe = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      alert("Lendo Nota Fiscal... Aguarde.");
      const res = await api.post("/toner/import-nfe", formData, { headers: { "Content-Type": "multipart/form-data" } });
      alert(res.data.message);
      loadInitialData(); 
    } catch (err) { alert(err.response?.data?.detail || "Erro ao ler o XML."); } 
  };

  const openEditModal = (toner) => {
    setAddForm({
      id: toner.id,
      model: toner.model,
      description: toner.description,
      stock: toner.stock,
      cost_price: toner.cost_price || "",
      profit_margin: toner.profit_margin || "",
      sale_price: toner.sale_price || "",
      color: "PRETO" 
    });
    setIsAddOpen(true);
  };

  const handleSaveToner = async () => {
    try {
      const payload = {
        model: addForm.model,
        description: addForm.id ? addForm.description : generatedDescription,
        stock: parseInt(addForm.stock) || 0,
        cost_price: parseFloat(addForm.cost_price) || 0.00,
        profit_margin: parseFloat(addForm.profit_margin) || 0.00,
        sale_price: parseFloat(addForm.sale_price) || 0.00
      };

      if (addForm.id) { await api.put(`/toner/${addForm.id}`, payload); } 
      else { await api.post("/toner", payload); }
      
      closeAndReload();
    } catch (err) { alert("Erro ao salvar insumo."); }
  };

  const handleDeleteToner = async (id) => {
    if (window.confirm("Deseja realmente excluir este insumo?")) {
      try { await api.delete(`/toner/${id}`); loadInitialData(); } 
      catch (err) { alert(err.response?.data?.detail || "Erro ao excluir insumo."); }
    }
  };

  async function openHistory(toner) {
    setSelectedToner(toner);
    try {
      const res = await api.get(`/toner/${toner.id}/history`);
      setTonerHistory(res.data || []);
      setIsHistoryOpen(true);
    } catch (err) { console.error(err); }
  }

  const closeAndReload = () => {
    setIsAddOpen(false);
    setIsHistoryOpen(false);
    setSelectedToner(null);
    setAddForm({ id: null, model: "", color: "PRETO", stock: 0, cost_price: "", profit_margin: "", sale_price: "" });
    loadInitialData();
  };

  // ==========================================
  // 🛒 LÓGICA DO CARRINHO LOGÍSTICO (NOVO)
  // ==========================================
  const handleQtyChange = (tonerId, delta, stock) => {
    setRowQuantities(prev => {
      const current = prev[tonerId] || 1;
      let next = current + delta;
      if (next < 1) next = 1;
      if (next > stock) next = stock;
      return { ...prev, [tonerId]: next };
    });
  };

  const getQty = (tonerId) => rowQuantities[tonerId] || 1;

  const addToCart = (toner) => {
    const qty = getQty(toner.id);
    if (toner.stock < qty) return alert("Estoque insuficiente!");
    
    const cartItem = {
      cart_id: Date.now() + Math.random(), 
      toner_id: toner.id,
      model: toner.model,
      description: toner.description,
      quantity: qty,
      client_id: globalClient || "",
      printer_id: globalPrinter || "",
      notes: "Envio de Suprimento",
      max_stock: toner.stock
    };
    
    setCart(prev => [...prev, cartItem]);
    setIsCartOpen(true);
    setRowQuantities(prev => ({ ...prev, [toner.id]: 1 })); // Reseta input
  };

  const removeCartItem = (cartId) => {
    setCart(prev => prev.filter(item => item.cart_id !== cartId));
    if (cart.length === 1) setIsCartOpen(false);
  };

  const updateCartItem = (cartId, field, value) => {
    setCart(prev => prev.map(item => item.cart_id === cartId ? { ...item, [field]: value } : item));
  };

  const applyGlobalTarget = () => {
    if(!globalClient) return alert("Selecione um cliente global primeiro.");
    setCart(prev => prev.map(item => ({ ...item, client_id: globalClient, printer_id: globalPrinter })));
  };

  const submitCart = async () => {
    for (let item of cart) {
      if (!item.client_id || !item.printer_id) {
        return alert(`Preencha o Destino (Cliente e Máquina) para o item: ${item.model}`);
      }
    }
    setIsSubmitting(true);
    try {
      const payload = {
        items: cart.map(item => ({
          toner_id: item.toner_id,
          quantity: item.quantity,
          client_id: parseInt(item.client_id),
          printer_id: parseInt(item.printer_id),
          notes: item.notes
        }))
      };
      const res = await api.post("/toner/delivery", payload);
      alert(res.data.message || "Lote despachado!");
      setCart([]);
      setIsCartOpen(false);
      loadInitialData(); 
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao despachar o lote.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Busca Inteligente (Preservada)
  const filteredToners = toners.filter(t => {
    if (!searchTerm || searchTerm.trim() === "") return true;
    const termosBusca = searchTerm.toLowerCase().trim().split(" ");
    const textoAlvo = `${t.model || "Universal"} ${t.description || ""}`.toLowerCase();
    return termosBusca.every(termo => textoAlvo.includes(termo));
  });

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 p-4 pb-20 bg-transparent space-y-8 relative overflow-x-hidden">
      
      {/* 🔍 HEADER PREMIUM */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 bg-white/70 backdrop-blur-xl p-8 rounded-[40px] border border-white/50 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-500">
        <div>
          <h1 className="text-4xl font-black text-slate-900 tracking-tighter">Estoque de <span className="text-indigo-600">Peças</span></h1>
          <p className="text-[10px] text-slate-400 font-black uppercase tracking-[0.3em] mt-2 ml-1">Centro de Distribuição</p>
        </div>
        
        <div className="flex flex-col md:flex-row gap-4 w-full lg:w-auto">
          <div className="relative group w-full lg:w-72">
            <input 
              type="text"
              placeholder="Buscar insumo..." 
              className="w-full p-4 pl-12 bg-white/80 border border-slate-200/60 rounded-2xl text-sm font-bold shadow-inner outline-none focus:bg-white focus:ring-4 ring-indigo-500/10 focus:border-indigo-400 transition-all placeholder:text-slate-400" 
              value={searchTerm} 
              onChange={(e) => setSearchTerm(e.target.value)} 
            />
            <span className="absolute left-4 top-4 text-lg opacity-40 group-focus-within:text-indigo-600 group-focus-within:opacity-100 group-focus-within:scale-110 transition-all duration-300">🔍</span>
          </div>
          
          <div className="flex gap-3">
            <label className="px-6 py-4 bg-emerald-600 text-white font-black rounded-2xl shadow-xl hover:bg-emerald-500 hover:-translate-y-1 transition-all duration-300 active:scale-95 flex items-center gap-2 text-[10px] uppercase tracking-widest cursor-pointer">
              <span>🧾</span> Importar NFe
              <input type="file" accept=".xml" className="hidden" onChange={handleImportNFe} />
            </label>

            {/* BOTÃO DO CARRINHO */}
            <button onClick={() => setIsCartOpen(true)} className="px-6 py-4 bg-slate-900 text-white font-black rounded-2xl shadow-xl hover:bg-indigo-600 hover:-translate-y-1 transition-all duration-300 active:scale-95 flex items-center gap-2 text-[10px] uppercase tracking-widest relative">
              <span>🛒</span> Lote
              {cart.length > 0 && <span className="absolute -top-2 -right-2 w-6 h-6 bg-rose-500 rounded-full flex items-center justify-center text-white text-[10px] animate-pulse">{cart.length}</span>}
            </button>

            <button onClick={() => { setAddForm({ id: null, model: "", color: "PRETO", stock: 0, cost_price: "", profit_margin: "", sale_price: "" }); setIsAddOpen(true); }} className="px-6 py-4 bg-indigo-600 text-white font-black rounded-2xl shadow-xl shadow-indigo-600/20 hover:bg-indigo-500 hover:-translate-y-1 transition-all duration-300 active:scale-95 flex items-center gap-2 text-[10px] uppercase tracking-widest">
              <span>📦</span> Novo
            </button>
          </div>
        </div>
      </div>

     {/* 📋 TABELA GLASSMORPHISM OTIMIZADA */}
      <div className="bg-white/60 backdrop-blur-md rounded-[40px] border border-white/60 shadow-xl shadow-slate-200/40 overflow-hidden transition-all duration-500">
        <table className="w-full text-left table-fixed">
          <thead className="bg-slate-50/60 text-[10px] font-black uppercase text-slate-500 tracking-widest border-b border-slate-200/50">
            <tr>
              <th className="p-6 md:p-8 w-1/3 md:w-auto">Modelo / Descrição</th>
              <th className="p-6 md:p-8 text-center w-28 md:w-36">Custo Unitário</th>
              <th className="p-6 md:p-8 text-center w-28 md:w-36">Estoque Atual</th>
              <th className="p-6 md:p-8 text-right w-48 md:w-[350px]">Ações Logísticas</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100/50">
            {filteredToners.map((t, index) => {
              const qty = getQty(t.id);
              const isZero = t.stock <= 0;

              return (
                <tr key={t.id} className={`hover:bg-white/80 transition-all duration-300 group border-l-4 ${isZero ? 'border-l-rose-500' : 'border-l-transparent hover:border-l-indigo-500'}`} style={{ animationDelay: `${index * 15}ms` }}>
                  
                  <td className="p-6 md:p-8 overflow-hidden">
                    <p className="font-black text-slate-800 text-sm md:text-lg uppercase tracking-tight group-hover:text-indigo-600 transition-colors truncate" title={t.model}>{t.model}</p>
                    <p className="text-[9px] md:text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1 truncate" title={t.description}>{t.description}</p>
                  </td>
                  
                  <td className="p-6 md:p-8 text-center">
                    <span className="bg-emerald-50 border border-emerald-100/50 text-emerald-600 px-3 md:px-4 py-2 rounded-xl text-[9px] md:text-[10px] font-black tracking-widest shadow-sm whitespace-nowrap">
                      R$ {Number(t.cost_price || 0).toFixed(2).replace('.', ',')}
                    </span>
                  </td>

                  <td className="p-6 md:p-8 text-center">
                    {isZero ? (
                      <span className="bg-rose-50 border border-rose-200 text-rose-600 px-3 md:px-4 py-2 rounded-xl text-[10px] md:text-xs font-black shadow-sm flex items-center justify-center gap-1 w-fit mx-auto animate-pulse">⚠️ ZERO</span>
                    ) : (
                      <span className="text-lg md:text-xl font-black text-slate-800 group-hover:text-indigo-600 transition-colors">{t.stock}</span>
                    )}
                  </td>

                  <td className="p-6 md:p-8 text-right">
                    <div className="flex items-center justify-end gap-2 md:gap-3">
                      
                      {/* Botões Auxiliares (Histórico e Editar) */}
                      <div className="flex gap-1">
                        <button onClick={() => openHistory(t)} className="p-2 bg-white border border-slate-200 text-slate-400 rounded-xl hover:bg-slate-100 hover:text-slate-700 transition-all shadow-sm" title="Histórico">⏳</button>
                        <button onClick={() => openEditModal(t)} className="p-2 bg-white border border-slate-200 text-slate-400 rounded-xl hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200 transition-all shadow-sm" title="Editar">✏️</button>
                      </div>

                      {/* 🚀 Controle de Quantidade e Despacho */}
                      <div className="flex items-center gap-2">
                        <div className="flex items-center bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm">
                          <button 
                            disabled={isZero} 
                            onClick={() => handleQtyChange(t.id, -1, t.stock)} 
                            className="px-3 py-2 text-slate-500 hover:bg-slate-100 font-black text-sm transition-colors disabled:opacity-50"
                          >
                            −
                          </button>
                          <span className="w-8 text-center text-xs font-black text-slate-800 tabular-nums">
                            {isZero ? 0 : qty}
                          </span>
                          <button 
                            disabled={isZero} 
                            onClick={() => handleQtyChange(t.id, 1, t.stock)} 
                            className="px-3 py-2 text-slate-500 hover:bg-slate-100 font-black text-sm transition-colors disabled:opacity-50"
                          >
                            +
                          </button>
                        </div>
                        
                        <button 
                          disabled={isZero} 
                          onClick={() => addToCart(t)} 
                          className="bg-slate-900 text-white px-4 py-2 rounded-xl font-black text-[9px] uppercase tracking-widest hover:bg-indigo-600 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap active:scale-95"
                        >
                          Por no Lote 📦
                        </button>
                      </div>

                    </div>
                  </td>
                </tr>
              );
            })}
            {filteredToners.length === 0 && (
              <tr><td colSpan="4" className="p-20 text-center text-slate-400 font-black uppercase tracking-widest text-[10px]">Inventário Vazio ou Produto Não Encontrado.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= MODAIS NATIVOS OVERLAY (FIM DO X DUPLO) ================= */}

      {/* 📦 NOVO/EDITAR INSUMO */}
      {isAddOpen && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/40 backdrop-blur-sm flex justify-center items-center p-4 animate-in fade-in duration-300">
          <div className="bg-white rounded-[35px] w-full max-w-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
            <div className="p-6 md:p-8 max-h-[90vh] overflow-y-auto custom-scrollbar text-slate-800">
              
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h2 className="text-3xl font-black mb-1 text-slate-900 tracking-tighter uppercase">{addForm.id ? "Ajustar Ativo" : "Novo Insumo"}</h2>
                  <p className="text-[10px] font-black text-indigo-500 uppercase tracking-[0.3em]">Cadastro de Almoxarifado</p>
                </div>
                <button onClick={closeAndReload} className="text-slate-400 hover:text-rose-500 text-2xl font-black transition-colors px-2">✕</button>
              </div>
              
              <div className="space-y-5">
                <div className="group">
                  <label className="text-[10px] font-black uppercase text-slate-400 ml-4 mb-1 block group-focus-within:text-indigo-600 transition-colors">Modelo (Referência Comercial)</label>
                  <input placeholder="Ex: HP 105A" className="w-full p-5 bg-slate-50 hover:bg-white border border-slate-200 rounded-2xl font-black outline-none focus:ring-4 ring-indigo-500/10 focus:border-indigo-400 uppercase transition-all shadow-inner" value={addForm.model} onChange={e => setAddForm({...addForm, model: e.target.value.toUpperCase()})} />
                </div>
                
                {!addForm.id && (
                  <div className="group">
                    <label className="text-[10px] font-black uppercase text-slate-400 ml-4 mb-1 block group-focus-within:text-indigo-600 transition-colors">Cor do Insumo</label>
                    <select className="w-full p-5 bg-slate-50 hover:bg-white border border-slate-200 rounded-2xl font-black outline-none focus:ring-4 ring-indigo-500/10 focus:border-indigo-400 transition-all shadow-inner cursor-pointer" value={addForm.color} onChange={e => setAddForm({...addForm, color: e.target.value})}>
                      <option value="PRETO">⚫ Preto (K)</option><option value="CIANO">🔵 Ciano (C)</option><option value="MAGENTA">🔴 Magenta (M)</option><option value="AMARELO">🟡 Amarelo (Y)</option>
                    </select>
                  </div>
                )}

                <div className="p-5 bg-indigo-50 border border-indigo-100 text-indigo-700 rounded-2xl font-black text-center text-[10px] tracking-widest shadow-sm uppercase">
                  <span className="opacity-50 mr-2">Nomenclatura Final:</span>
                  {addForm.id ? addForm.description : generatedDescription}
                </div>
                
                <div className="group">
                  <label className="text-[10px] font-black uppercase text-slate-400 ml-4 mb-1 block group-focus-within:text-slate-800 transition-colors">Qtd. Inicial (Estoque)</label>
                  <input type="number" placeholder="0" className="w-full p-5 bg-slate-50 hover:bg-white border border-slate-200 rounded-2xl font-black text-xl text-center outline-none focus:ring-4 ring-slate-500/10 transition-all shadow-inner" value={addForm.stock} onChange={e => setAddForm({...addForm, stock: parseInt(e.target.value) || 0})} />
                </div>

                <div className="grid grid-cols-3 gap-4 bg-slate-50 p-4 rounded-2xl border border-slate-200">
                  <div className="group">
                    <label className="text-[9px] font-black uppercase text-slate-500 ml-2 mb-1 block">Custo (R$)</label>
                    <input type="number" step="0.01" className="w-full p-4 bg-white border border-slate-200 rounded-xl font-black text-slate-700 text-center outline-none focus:border-indigo-400 transition-all shadow-sm" value={addForm.cost_price} onChange={e => handlePricingChange('cost_price', e.target.value)} />
                  </div>
                  <div className="group">
                    <label className="text-[9px] font-black uppercase text-indigo-500 ml-2 mb-1 block">% Lucro</label>
                    <input type="number" step="0.01" className="w-full p-4 bg-indigo-50/50 border border-indigo-200 rounded-xl font-black text-indigo-700 text-center outline-none focus:border-indigo-400 transition-all shadow-sm" value={addForm.profit_margin} onChange={e => handlePricingChange('profit_margin', e.target.value)} />
                  </div>
                  <div className="group">
                    <label className="text-[9px] font-black uppercase text-emerald-600 ml-2 mb-1 block">Venda (R$)</label>
                    <input type="number" step="0.01" className="w-full p-4 bg-emerald-50 border border-emerald-200 rounded-xl font-black text-emerald-700 text-center outline-none focus:border-emerald-400 transition-all shadow-sm" value={addForm.sale_price} onChange={e => handlePricingChange('sale_price', e.target.value)} />
                  </div>
                </div>

                <button onClick={handleSaveToner} className="w-full py-6 bg-indigo-600 text-white font-black rounded-3xl shadow-lg hover:bg-indigo-500 hover:-translate-y-1 transition-all uppercase text-[11px] tracking-[0.2em] active:scale-95 mt-4">
                  Salvar Base de Dados 🚀
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ⏳ HISTÓRICO OVERLAY */}
      {isHistoryOpen && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/40 backdrop-blur-sm flex justify-center items-center p-4 animate-in fade-in duration-300">
          <div className="bg-white rounded-[35px] w-full max-w-xl shadow-2xl overflow-hidden animate-in slide-in-from-left-8 duration-300">
            <div className="p-6 md:p-8">
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h2 className="text-3xl font-black text-slate-900 tracking-tighter uppercase mb-1">Rastreio de Ativo</h2>
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Histórico de Saídas</p>
                </div>
                <button onClick={closeAndReload} className="text-slate-400 hover:text-rose-500 text-2xl font-black transition-colors px-2">✕</button>
              </div>
              
              <div className="space-y-4 max-h-[450px] overflow-y-auto pr-3 custom-scrollbar border-t border-slate-100 pt-6">
                {tonerHistory.map((h, i) => (
                  <div key={i} className="flex justify-between items-center p-5 bg-slate-50 border border-slate-100 rounded-[24px] shadow-sm hover:border-indigo-200 transition-colors group">
                    <div>
                      <p className="text-[10px] font-black text-indigo-500 uppercase tracking-widest mb-1">{h.model}</p>
                      <p className="font-black text-slate-800 text-sm uppercase leading-tight">{h.target}</p>
                      <p className="text-[9px] text-slate-400 font-bold mt-2 bg-white border border-slate-200 px-2 py-0.5 rounded w-fit">{new Date(h.date).toLocaleDateString()}</p>
                    </div>
                    <div className="flex flex-col items-center">
                      <span className="bg-rose-50 text-rose-600 px-4 py-2 rounded-xl font-black text-sm border border-rose-100 shadow-sm">- {h.quantity} UN</span>
                    </div>
                  </div>
                ))}

                {tonerHistory.length === 0 && (
                  <div className="flex flex-col items-center justify-center py-10 opacity-50">
                      <span className="text-4xl mb-3">🗄️</span>
                      <p className="text-center text-slate-400 font-black uppercase tracking-widest text-[10px]">Ativo sem movimentação recente.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 🚀 BARRA LATERAL LOGÍSTICA (CARRINHO E-COMMERCE) */}
      <div className={`fixed top-0 right-0 h-full w-full sm:max-w-md bg-white shadow-[-20px_0_50px_rgba(0,0,0,0.1)] z-[9999] transform transition-transform duration-500 ease-in-out border-l border-slate-200 flex flex-col ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}`}>
         
         <div className="flex justify-between items-center p-6 border-b border-slate-100 bg-slate-50">
            <div>
              <h2 className="text-xl font-black text-slate-900 uppercase tracking-tighter">Lote de Despacho</h2>
              <p className="text-[9px] font-black text-indigo-600 uppercase tracking-widest mt-1">Multi-Envio Logístico</p>
            </div>
            <button onClick={() => setIsCartOpen(false)} className="w-10 h-10 flex items-center justify-center bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-rose-500 font-black shadow-sm transition-colors">✕</button>
         </div>

         <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar bg-white">
            
            {/* Controles Globais do Lote */}
            {cart.length > 0 && (
              <div className="bg-indigo-50 border border-indigo-100 p-5 rounded-[25px] shadow-sm animate-in fade-in">
                <p className="text-[9px] font-black text-indigo-800 uppercase tracking-widest mb-3 text-center">Aplicar Destino em Massa</p>
                <div className="space-y-3">
                  <select className="w-full bg-white border border-indigo-200 px-3 py-2.5 rounded-xl text-xs font-bold text-slate-700 outline-none uppercase cursor-pointer" value={globalClient} onChange={e => { setGlobalClient(e.target.value); setGlobalPrinter(""); }}>
                    <option value="">1. Selecione a Empresa Global...</option>
                    {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <select className="w-full bg-white border border-indigo-200 px-3 py-2.5 rounded-xl text-xs font-bold text-slate-700 outline-none uppercase disabled:opacity-50 cursor-pointer" disabled={!globalClient} value={globalPrinter} onChange={e => setGlobalPrinter(e.target.value)}>
                    <option value="">2. Selecione a Máquina Global...</option>
                    {printers.filter(p => p.client_id === parseInt(globalClient)).map(p => <option key={p.id} value={p.id}>{p.model} (SN: {p.serial})</option>)}
                  </select>
                  <button onClick={applyGlobalTarget} className="w-full py-3 bg-indigo-600 text-white rounded-xl font-black text-[9px] uppercase tracking-widest hover:bg-indigo-700 transition-colors shadow-md active:scale-95">
                    ⬇️ Preencher itens abaixo
                  </button>
                </div>
              </div>
            )}

            {cart.length === 0 && (
              <div className="h-full flex flex-col items-center justify-center text-slate-400 space-y-4 pt-20">
                <span className="text-6xl opacity-30">🛒</span>
                <p className="font-black text-[10px] uppercase tracking-widest text-center px-10">Carrinho Vazio.<br/>Adicione insumos da tabela para criar um lote de despacho.</p>
              </div>
            )}

            {/* Itens do Carrinho */}
            <div className="space-y-4">
              {cart.map((item) => (
                <div key={item.cart_id} className="bg-slate-50 border border-slate-200 p-4 rounded-[20px] relative group animate-in slide-in-from-right-4">
                  <button onClick={() => removeCartItem(item.cart_id)} className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center bg-rose-100 text-rose-600 rounded-md opacity-0 group-hover:opacity-100 transition-opacity font-black text-xs hover:bg-rose-500 hover:text-white">✕</button>
                  
                  <div className="flex items-center gap-3 mb-3 pr-6">
                    <span className="bg-slate-900 text-white w-6 h-6 rounded-md flex items-center justify-center text-[10px] font-black">{item.quantity}x</span>
                    <p className="font-black text-[11px] text-slate-800 uppercase line-clamp-2 flex-1" title={item.description}>{item.model} - {item.description}</p>
                  </div>

                  <div className="space-y-2">
                    <select className="w-full bg-white border border-slate-200 px-3 py-2 rounded-lg text-[10px] font-bold text-slate-700 outline-none uppercase cursor-pointer focus:border-indigo-400 transition-colors" value={item.client_id} onChange={e => { updateCartItem(item.cart_id, 'client_id', e.target.value); updateCartItem(item.cart_id, 'printer_id', ""); }}>
                      <option value="">Destino: Empresa...</option>
                      {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>

                    <select className="w-full bg-white border border-slate-200 px-3 py-2 rounded-lg text-[10px] font-bold text-slate-700 outline-none uppercase cursor-pointer disabled:opacity-50 focus:border-indigo-400 transition-colors" disabled={!item.client_id} value={item.printer_id} onChange={e => updateCartItem(item.cart_id, 'printer_id', e.target.value)}>
                      <option value="">Destino: Máquina...</option>
                      {printers.filter(p => p.client_id === parseInt(item.client_id)).map(p => <option key={p.id} value={p.id}>{p.model}</option>)}
                    </select>
                  </div>
                </div>
              ))}
            </div>
         </div>

         {/* Rodapé do Carrinho */}
         <div className="p-6 border-t border-slate-100 bg-white">
            <button disabled={cart.length === 0 || isSubmitting} onClick={submitCart} className="w-full py-5 bg-slate-900 text-white rounded-2xl font-black text-[11px] uppercase tracking-widest hover:bg-emerald-600 transition-all shadow-lg active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2">
              {isSubmitting ? <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : "Concluir Lote Logístico 🚀"}
            </button>
         </div>
      </div>

    </div>
  );
}